import { UtilsIcons } from 'utils/icons';

let prefetcherCalled = false;

export const IconsPrefetcher = () => {
  const prefetchIcons = () => {
    const iconUrl = UtilsIcons.createUrl({
      lib: 'generic',
      theme: 'default',
      name: 'spin'
    });

    const iconRemoveUrl = UtilsIcons.createUrl({
      lib: 'generic',
      theme: 'colored',
      name: 'remove'
    });

    void UtilsIcons.prefetch(iconUrl);
    void UtilsIcons.prefetch(iconRemoveUrl);
    prefetcherCalled = true;
  };

  !prefetcherCalled && prefetchIcons();

  return null;
};
